import { PartialType } from '../../../../utils';
import { CreateVehicleMaintenanceTypeDto } from '../create/create-vehicle-maintenance-type.dto';
export class UpdateVehicleMaintenanceTypeDto extends PartialType(CreateVehicleMaintenanceTypeDto) {
}
